'use strict';

module.exports = require('string.prototype.trimstart/implementation');